import { AsyncActionStatus } from '../enums';

const makeAsyncReducerHandlers = (
  asyncActionTypes,
  pendingHandler = state => state,
  fulfilledHandler = state => state,
  rejectedHandler = state => state,
) => ({
  [asyncActionTypes[AsyncActionStatus.PENDING]]: pendingHandler,
  [asyncActionTypes[AsyncActionStatus.FULFILLED]]: fulfilledHandler,
  [asyncActionTypes[AsyncActionStatus.REJECTED]]: rejectedHandler,
});

export default makeAsyncReducerHandlers;
